import * as React from "react";
const ThreeDoorXXLSize = ({ isActive = false }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={82}
    height={71}
    viewBox="0 0 82 71"
    fill={isActive ? "#292747" : "#9493A3"}
    className="gg-scale-[70%] gg-transition gg-duration-150 gg-ease-in-out sm:gg-scale-75 lg:gg-scale-[70%] xl:gg-scale-75 2xl:gg-scale-90"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 0v55.43h82V0h-5.06v50.37H5.06V0z"
    />
    <path d="M26.5 0h3v54h-3zm26 0h3v54h-3z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.15 67.354a.5.5 0 0 1 0-.707l3.182-3.182a.5.5 0 1 1 .707.707L1.711 66.5h78.505l-2.328-2.328a.5.5 0 0 1 .707-.707l3.182 3.182a.5.5 0 0 1 0 .707l-3.182 3.182a.5.5 0 1 1-.707-.707l2.328-2.329H1.711l2.328 2.329a.5.5 0 1 1-.707.707z"
      fill="#7F7D91"
    />
  </svg>
);
export default ThreeDoorXXLSize;
